import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  // Sobrescreve o rodapé do Card (que vem com borda no topo) para o botão de
  // salvar ficar apenas alinhado à direita.
  cardFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: theme.spacing(0, 2, 2),
  },
}))

export default styles
